import React, { useState, useEffect } from 'react';
import CommonHeader from '@/components/CommonHeader';
import $i18n from '@/i18n';
import { Icon, Message, Modal } from '@b-design/fusion';
import Button from '@/components/Button';
import styles from './index.module.less';
import AddMemberModal from '../addMemberModal/indexCp';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';

const breadcrumbConfig = [
  {
    key: 'members',
    breadcrumbName: $i18n.get({ id: 'aopf.pages.member.tabMembers', dm: '成员' }),
    path: '/members',
  },
];

interface Header {
  roleList: string[];
  queryInvitations: (params?: {
    spaceId: string;
    currentPage: number;
    pageSize: number;
    type: string;
  }) => void;
}

const Header: React.FC<Header> = ({ roleList, queryInvitations }) => {
  // 增加成员弹框
  const [addMemberVisible, setAddMemberVisible] = useState<boolean>(false);
  const { isTrue, spaceId } = getQueryStringArgs();

  useEffect(() => {
    if (isTrue) {
      setAddMemberVisible(true);
    }
  }, [isTrue]);

  const onAddMemberClose = () => {
    setAddMemberVisible(false);
  };

  const onFinish = async (values, error) => {
    if (error) {
      return;
    }

    const { appList, roleList: _roleList, ...last } = values;
    const params = {
      ...last,
      extInfo: _roleList?.includes('DEVELOPER')
        ? { appList: appList?.join(','), role: _roleList?.join(',') }
        : { role: _roleList?.join(',') },
      type: 'APP_DEVELOPER',
      spaceId,
    };
    try {
    const data = await Requests.post('/rest/intercnn/invitation/create', params, {}, true)
     if (data) {
          Message.success({
            title: $i18n.get({
              id: 'aopf.pages.channel.channelList.message.success.invitation',
              dm: '邀请成功',
            }),
          });
          onAddMemberClose();
          // 邀请成功后刷新邀请列表
          queryInvitations();
        } else {
          Message.error({
            title: $i18n.get({
              id: 'aopf.pages.channel.channelList.message.error',
              dm: '系统出错，稍后重试',
            }),
          });
        }
      } catch(error) {
        if (error?.errorCode === 'INTCNN_THIRD_SPACE_NUM_LIMIT') {
          Modal.error({
            title: $i18n.get({
              id: 'aopf.components.CreateMiniappDrawer.InvitationFailed',
              dm: '邀请失败',
            }),
            content: $i18n.get({
              id: 'aopf.components.CreateMiniappDrawer.TheMaximumInvitationValueHas',
              dm: '已达到最大邀请值',
            }),
            footer: null,
          });
        } else {
          Message.error(
            error?.Detail ||
            error?.errorMsg ||
            $i18n.get({
              id: 'aopf.pages.channel.channelList.message.error',
              dm: '系统出错，稍后重试',
            }),
          );
        }
      };
  };

  return (
    <div className={styles.memberContainer}>
      <CommonHeader
        title={$i18n.get({ id: 'aopf.pages.member.tabMembers', dm: '成员' })}
        // backTo={`/overview${location.search}`}
        breadcrumbs={breadcrumbConfig}
      />

      {roleList?.includes('ADMIN') || roleList?.includes('AIGC_DESIGNER') ? (
        <>
          <div className={styles.memberAddBtn}>
            <Button
              type="primary"
              data-child-type="icon-text"
              onClick={() => setAddMemberVisible(true)}
            >
              <Icon type="add--circle--filled" />
              {$i18n.get({ id: 'aopf.pages.member.addMembers', dm: '添加成员' })}
            </Button>
          </div>
          <AddMemberModal
            addMemberVisible={addMemberVisible}
            onAddMemberClose={onAddMemberClose}
            onFinish={onFinish}
            spaceId={spaceId || ''}
            roleList={roleList || []}
          />
        </>
      ) : null}
    </div>
  );
};
export default Header;
